import { render, staticRenderFns } from "./JobsPage.vue?vue&type=template&id=b0524ed0&scoped=true"
import script from "./JobsPage.vue?vue&type=script&lang=js"
export * from "./JobsPage.vue?vue&type=script&lang=js"
import style0 from "./JobsPage.vue?vue&type=style&index=0&id=b0524ed0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0524ed0",
  null
  
)

export default component.exports